module.exports = {
  "details": {
    "Beneficiary Name": "Mr Example",
    "Sort Code": "123456",
    "Account Number": "12344567"
  },
  "owner": "823cf470-74c4-4622-b040-11061b6ab45f",
  "id": "8a65d778-d0b8-4b8b-9bdd-925e8404b19e",
  "transfer_type": "FPS",
  "account": "GBP"
};